import { RestApiResponse } from '../../common/rest-api.response';
import { NomenclatureTypeChildParameter } from '../nomenclature-type-child-parameter';

export class NomenclatureTypeChildParameterGetListResponse extends RestApiResponse {
    public parameters?: NomenclatureTypeChildParameter[];

    constructor(data?: Partial<NomenclatureTypeChildParameterGetListResponse>) {
        super(data);
        this.parameters = Array.isArray(data?.parameters) ? data.parameters.map(p => new NomenclatureTypeChildParameter(p)) : [];
    }
}
